module.exports = __webpack_public_path__ + "static/media/processing.cc381a8c.svg";